import React from 'react'

const IconSvg = ({
  color = 'black',
  opacity = 1,
  ...props
}: {
  color?: string
  opacity?: number
  [x: string]: any
}) => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 13 11'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    opacity={opacity}
    style={{ verticalAlign: 'middle' }}
    {...props}
  >
    <path
      d='M11.5 0.5H1.5C0.8125 0.5 0.25625 1.0625 0.25625 1.75L0.25 9.25C0.25 9.9375 0.8125 10.5 1.5 10.5H11.5C12.1875 10.5 12.75 9.9375 12.75 9.25V1.75C12.75 1.0625 12.1875 0.5 11.5 0.5ZM11.5 9.25H1.5V3L6.5 6.125L11.5 3V9.25ZM6.5 4.875L1.5 1.75H11.5L6.5 4.875Z'
      fill={color}
    />
  </svg>
)

export default IconSvg
